import React from 'react';
import { articles } from './ArticleCard'; 
const ArticleContent = () => {
    const article1 = articles[0];
    return (
        <div className="text-2xl max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 my-20">
            <h1 className='font-bold'>{article1.title}</h1>
            <div 
                style={{
                    width: '60%',
                    height: '60%',
                    overflow: 'hidden',
                    margin: '40px auto'
                }}
                className="my-10"
            >
                <img 
                    src={article1.photoCover1} 
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center center'
                    }} 
                />
            </div>
            <p className='mb-10'>{article1.contentP1}</p>
            <p className='mb-10'>{article1.contentP2}</p>
            <div 
                style={{
                    width: '60%',
                    height: '60%',
                    overflow: 'hidden',
                    margin: '40px auto'
                }}
                className="my-10"
            >
                <img 
                    src={article1.photoCover2} 
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        objectPosition: 'center center'
                    }} 
                />
            </div>
            <p className='mb-10'>{article1.contentP3}</p>
            <p className='mb-10'>{article1.contentP4}</p>
        </div>
    );
};

export default ArticleContent;
